// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FOOTER_HELP_LINK = "Op\u00fdtaj sa n\u00e1s";
